import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Expense, ExpenseDTO } from '../../../../core/models/expense.interface';
import { ExpensesService } from '../../../../core/services/expenses/expenses-service';
import { LoadingService } from '../../../../core/services/loading/loading';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { FormUtils } from '../../../../shared/utils';

@Component({
  selector: 'app-expenses-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './expenses-form.html',
  styleUrl: './expenses-form.scss',
})
export class ExpensesForm {
  expense: string | null = null;
  errorMsg: string[] | null = null;
  expenseSelected: Expense | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<ExpensesForm>,
    private toastr: ToastrService,
    private serviceExpense: ExpensesService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceExpense.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceExpense.selectedexpense$.subscribe((expense) => {
      if (expense) {
        this.expense = String(expense.id);
        this.expenseSelected = expense;
        this.expenseForm.patchValue({
          ...expense,
        });
      }
    });
  }

  expenseForm = this.formBuilder.group({
    unity: ['', [Validators.required, Validators.maxLength(150)]],
    package: [0, [Validators.required]],
    value: [0, [Validators.required]],
    qty: [0, [Validators.required]],
    total: [0, [Validators.required]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveExpense() {
    const payload = this.expenseForm.value as ExpenseDTO;
    if (this.expenseForm.status === 'VALID' && !this.expense) {
      this.loadingService.show(true);
      this.serviceExpense.createExpense(payload).subscribe({
        next: (expense) => {
          this.loadingService.show(false);
          const msg = `El gasto ${expense.id} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.expenseForm.status === 'VALID' && this.expense) {
      this.loadingService.show(true);
      const id = Number(this.expense);
      this.serviceExpense.UpdateExpense(id, { ...payload, id: id }).subscribe({
        next: (expense) => {
          this.loadingService.show(false);
          const msg = `El gasto ${expense.id} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
